import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import banner from '../../assets/img/bg-banner.webp'
import { errorMessage } from '../../constants/errorMessage'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

function Header(props) {
    const { loggedInError, partnerDetails, facility} = props
    const COO_Facilities = [163, 528, 529, 530, 531, 532, 533]

  return (
    <section className="mt-5">
        <div className='bannerTop' style={{backgroundImage: `url(${partnerDetails  ? (partnerDetails?.brand_setting && partnerDetails?.brand_setting?.customerbannerurl && partnerDetails?.brand_setting?.customer_banner) ? partnerDetails?.brand_setting?.customerbannerurl : partnerDetails?.partner_details?.brand_setting?.customerbannerurl ? partnerDetails?.partner_details?.brand_setting?.customerbannerurl : banner : banner})`}}>
            <div className='container '>
             {COO_Facilities?.includes(facility?.id) ? <h1 className='seamless-title text-center text-white fw-bold'>County of Orange monthly Permit Portal</h1> : <h1 className='seamless-title text-center text-white fw-bold'>{partnerDetails  ? (partnerDetails?.brand_setting && partnerDetails?.brand_setting?.customer_banner_heading) ? partnerDetails?.brand_setting?.customer_banner_heading : partnerDetails?.partner_details?.brand_setting?.customer_banner_heading ? partnerDetails?.partner_details?.brand_setting?.customer_banner_heading : errorMessage?.customer_banner_heading : errorMessage?.customer_banner_heading}</h1>}
             <p className='seamless-title text-white text-center'>{COO_Facilities?.includes(facility?.id) ? null : partnerDetails  ? (partnerDetails?.brand_setting && partnerDetails?.brand_setting?.customer_banner_text) ? partnerDetails?.brand_setting?.customer_banner_text : partnerDetails?.partner_details?.brand_setting?.customer_banner_text ? partnerDetails?.partner_details?.brand_setting?.customer_banner_text : errorMessage?.customer_banner_text : errorMessage?.customer_banner_text}</p>
            </div>
        </div>
        
            <div className="container ">
                <div className="row justify-content-md-end">
                {loggedInError && <div className="alert alert-danger">
                    <strong>Danger!</strong> {loggedInError}.
                </div>}
                    <div className="col-sm-6 me-4">
                    <div className="p-3 topBox text-white">
                                {/* <h1 >We Make Parking Easy</h1>
                                <p>
                                    Parking Offers the smooth and easy parking process, which helps you to
                                    book your monthly parking hassle free and easy.
                                </p> */}
                                {/* {page == 'thankyou' ? <a href="" className="btn btn-primary">Buy Now</a>: <a href="#forms" className="btn btn-primary">Buy Now</a>} */}
                            </div>
                        

                    </div>
                </div>
            </div>
        </section>
  )
}

Header.propTypes = {
	page: PropTypes.string,
	loggedInError: PropTypes.string,
    partnerDetails: PropTypes.object,
    facility: PropTypes.object,
}

Header.defaulProps = {
	page: undefined,
	loggedInError: undefined,
    partnerDetails: EMPTY_OBJECT,
    facility: EMPTY_OBJECT
}

function mapStateToProps({ login, paymentReducer }) {
	return {
		isAuthenticated: login?.isAuthenticated,
		userData: login?.data,
		permitData: paymentReducer?.data
	}
}
export default connect(mapStateToProps)(Header)
